import { render, staticRenderFns } from "./CaseUploadsListTable.vue?vue&type=template&id=d1b56a92"
import script from "./CaseUploadsListTable.vue?vue&type=script&lang=js"
export * from "./CaseUploadsListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports